export function dateToDMY(date: Date) {
  const d = date.getDate();
  const m = date.getMonth() + 1; // Month from 0 to 11
  const y = date.getFullYear();
  return `${d <= 9 ? `0${d}` : d}.${m <= 9 ? `0${m}` : m}.${y}`;
}
